import { StepConfig } from './types';

export const TOTAL_STEPS = 8;

export const STEP_CONFIGS: StepConfig[] = [
  {
    id: 0,
    title: 'Build Your Brand Profile',
    description: "Choose how you'd like to get started with your brand onboarding.",
    validationFields: [],
  },
  {
    id: 1,
    title: 'Onboarding Questionaire',
    description: 'Help us understand your product and what makes it stand out.',
    validationFields: ['step1_productFeatures'],
  },
  {
    id: 2,
    title: 'Unique Selling Propositions & Brand Identity',
    description: 'Tell us about your brand personality and values.',
    validationFields: ['step2_brandIdentity'],
  },
  {
    id: 3,
    title: 'Competitive Landscape',
    description: 'Identify your competitors and unique differentiators.',
    validationFields: ['step3_competitiveLandscape'],
  },
  {
    id: 4,
    title: 'Target Market & Customer Demographics',
    description: 'Define your customer personas and geographic targeting.',
    validationFields: ['step4_targetMarket'],
  },
  {
    id: 5,
    title: 'Business Goals & Future Plans',
    description: 'Understand your business model, budgets, and vision.',
    validationFields: ['step5_businessGoals'],
  },
  {
    id: 6,
    title: "Company's Online Presence",
    description: 'Capture how your brand operates online and communicates.',
    validationFields: ['step6_onlinePresence'],
  },
  {
    id: 7,
    title: 'Brand Assets',
    description: 'Upload branding materials and define tone/voice consistency.',
    validationFields: ['step7_brandAssets'],
  },
  {
    id: 8,
    title: 'Onboarding Summary',
    description: 'Review and confirm all inputs before launching your workspace.',
    validationFields: [],
  },
];

export const COMPANY_SCALE_OPTIONS = [
  { value: 'local', label: 'Local (within one city/region)' },
  { value: 'regional', label: 'Regional (multiple cities/states)' },
  { value: 'national', label: 'National (country-wide)' },
  { value: 'international', label: 'International (multiple countries)' },
  { value: 'global', label: 'Global (worldwide presence)' },
];

export const AREAS_SERVED_OPTIONS = [
  { value: 'north-america', label: 'North America' },
  { value: 'europe', label: 'Europe' },
  { value: 'asia', label: 'Asia' },
  { value: 'south-america', label: 'South America' },
  { value: 'africa', label: 'Africa' },
  { value: 'oceania', label: 'Oceania' },
  { value: 'middle-east', label: 'Middle East' },
  { value: 'central-america', label: 'Central America' },
];
